export default "__VITE_ASSET__DAVKmtrl__"